<template lang="pug">
.whatsapp-button
  v-btn(
    v-if="!Array.isArray(tel)",
    :href="`https://wa.me/55${tel}?text=${text}`",
    fab,
    target="_blank",
    color="#00E676",
    rel="noreferrer",
    aria-label="WhatsApp",
    dark,
    fixed,
    bottom,
    right
  )
    v-icon fab fa-whatsapp
  v-menu(v-else, offset-y, top)
    template(#activator="{ on, attrs }")
      v-btn(
        v-bind="attrs",
        v-on="on",
        fab,
        color="#00E676",
        aria-label="WhatsApp",
        dark,
        fixed,
        bottom,
        right
      )
        v-icon fab fa-whatsapp
    v-list-item-group
      v-list(color="#00E676", dense, dark)
        v-list-item(
          v-for="(t, i) in tel",
          :key="i",
          :href="`https://wa.me/55${t.tel}?text=${text}`",
          aria-label="E-mail",
          rel="noopener",
          target="_blank",
          link
        )
          v-list-item-icon.mr-2(v-if="t.icon")
            v-icon(small) {{ t.icon }}
          v-list-item-content
            v-list-item-title {{ t.name }}
</template>

<script>
export default {
  props: {
    tel: {
      type: [String, Array],
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
.whatsapp-button-text {
  font-family: Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 17px;
  text-transform: none;
}
.whatsapp-button,
.whatsapp-button * {
  z-index: 9999;
}
</style>
